import { Directive } from '@angular/core';

@Directive({
  selector: '[fcSuffix]',
  host: {
    class: 'fc-suffix',
  },
})
export class SuffixDirective {}
